export default __webpack_public_path__ + "static/media/Miss_Stacy.608e28ff.png";